import { CANONICAL_REGIONS, CanonicalRegion } from './requestRegions';

/**
 * The region dropdown's options.
 *
 * ⚠️ THE LABEL IS CANONICAL, THE VALUE IS LOWER CASE, AND THAT GAP IS WHY #1507's
 * supervisor stopped getting her digest. This control writes `nam` while imports
 * and the Bedrock schema write `NAM` — harmless against a case-insensitive
 * collation, and the reason nobody noticed the column had no single spelling
 * until a reader compared it to a literal. The values are kept as they are
 * because changing what the form writes is a data migration, not a refactor; the
 * LIST is now derived so a fourth region cannot be added here and forgotten in
 * `requestRegions.ts`.
 */
export type RegionValue = Lowercase<CanonicalRegion>;

export const US_REGIONS: readonly {
  label: CanonicalRegion;
  value: RegionValue;
}[] = CANONICAL_REGIONS.map(region => ({
  label: region,
  value: region.toLowerCase() as RegionValue,
}));
